<template>
<div class="modal-footer"><a class="btn btn-default" type="button" href="javascript:history.back()">Voltar</a>
  <button class="btn btn-primary" type="submit" :disabled="disabled">Gravar</button>
</div>
</template>

<script>
export default {
  name: 'FooterButton',
  props: ['disabled']
}
</script>

<style lang="stylus" scoped>

</style>
